import React from "react";

export function SkeletonCard({ className = "" }) {
  return (
    <div
      data-testid="skeleton-card"
      className={[
        "animate-pulse rounded-lg border border-[#EAE3D2] bg-white p-6",
        className,
      ].join(" ")}
    >
      <div className="h-3 w-24 rounded bg-[#EAE3D2]" />
      <div className="mt-4 h-7 w-3/4 rounded bg-[#EAE3D2]" />
      <div className="mt-3 h-3 w-full rounded bg-[#EAE3D2]/70" />
      <div className="mt-2 h-3 w-5/6 rounded bg-[#EAE3D2]/70" />
    </div>
  );
}

export function SkeletonImage({ className = "" }) {
  return (
    <div
      data-testid="skeleton-image"
      className={[
        "animate-pulse rounded-md bg-[#EAE3D2]/70",
        className,
      ].join(" ")}
    />
  );
}

export function SkeletonGrid({ count = 6, item: Item = SkeletonCard }) {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <Item key={i} />
      ))}
    </div>
  );
}
